module.exports = __webpack_public_path__ + "img/5.10b79a7b.png";